/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const CheckSquare = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m9 11 3 3L22 4" }],
    ["path", { d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" }]
  ]
];

export { CheckSquare as default };
//# sourceMappingURL=check-square.js.map
